// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-layout {
  display: flex;
  min-height: 100vh;
  background: #f5f5f5;
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.admin-content {
  flex: 1 1;
  margin-left: 250px;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s ease;
}

.admin-content.sidebar-closed {
  margin-left: 0;
}

.admin-header {
  background: white;
  padding: 20px 30px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.sidebar-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.sidebar-toggle:hover {
  background: #f5f5f5;
}

.sidebar-toggle:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.hamburger-icon {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 24px;
  height: 18px;
}

.hamburger-icon span {
  display: block;
  width: 100%;
  height: 2px;
  background: #333;
  border-radius: 2px;
  transition: all 0.3s;
}

.admin-header h1 {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.admin-header-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.admin-user-info {
  color: #666;
  font-size: 14px;
}

.logout-button {
  padding: 8px 16px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.logout-button:hover {
  background: #d32f2f;
}

.logout-button:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.admin-main {
  flex: 1 1;
  padding: 30px;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .sidebar-toggle {
    display: block;
  }
  
  .admin-content {
    margin-left: 0;
  }
  
  .admin-content.sidebar-open {
    margin-left: 0;
  }
  
  .admin-header {
    padding: 15px 20px;
    flex-wrap: wrap;
    gap: 15px;
  }
  
  .header-left {
    flex: 1 1;
    min-width: 0;
  }
  
  .admin-header-actions {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .admin-main {
    padding: 20px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/admin/AdminLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".admin-layout {\n  display: flex;\n  min-height: 100vh;\n  background: #f5f5f5;\n}\n\n.sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n.admin-content {\n  flex: 1;\n  margin-left: 250px;\n  display: flex;\n  flex-direction: column;\n  transition: margin-left 0.3s ease;\n}\n\n.admin-content.sidebar-closed {\n  margin-left: 0;\n}\n\n.admin-header {\n  background: white;\n  padding: 20px 30px;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.sidebar-toggle {\n  display: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 4px;\n  transition: background 0.2s;\n}\n\n.sidebar-toggle:hover {\n  background: #f5f5f5;\n}\n\n.sidebar-toggle:focus {\n  outline: 2px solid #1976d2;\n  outline-offset: 2px;\n}\n\n.hamburger-icon {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 24px;\n  height: 18px;\n}\n\n.hamburger-icon span {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: #333;\n  border-radius: 2px;\n  transition: all 0.3s;\n}\n\n.admin-header h1 {\n  margin: 0;\n  font-size: 24px;\n  color: #333;\n}\n\n.admin-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.admin-user-info {\n  color: #666;\n  font-size: 14px;\n}\n\n.logout-button {\n  padding: 8px 16px;\n  background: #f44336;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.logout-button:hover {\n  background: #d32f2f;\n}\n\n.logout-button:focus {\n  outline: 2px solid #1976d2;\n  outline-offset: 2px;\n}\n\n.admin-main {\n  flex: 1;\n  padding: 30px;\n  overflow-y: auto;\n}\n\n@media (max-width: 768px) {\n  .sidebar-toggle {\n    display: block;\n  }\n  \n  .admin-content {\n    margin-left: 0;\n  }\n  \n  .admin-content.sidebar-open {\n    margin-left: 0;\n  }\n  \n  .admin-header {\n    padding: 15px 20px;\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n  \n  .header-left {\n    flex: 1;\n    min-width: 0;\n  }\n  \n  .admin-header-actions {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n  \n  .admin-main {\n    padding: 20px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
